import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PiHelpFooterComponent } from '../pi-help-footer/pi-help-footer.component';
import { PiIndicadorFlujoComponent } from '../pi-indicador-flujo/pi-indicador-flujo.component';

@Component({
  selector: 'app-invalidez-layout',
  standalone: true,
  templateUrl: './invalidez-layout.component.html',
  styleUrls: ['./invalidez-layout.component.scss'],
  imports: [RouterModule, PiHelpFooterComponent, PiIndicadorFlujoComponent],
})
export class InvalidezLayoutComponent {

  constructor() { }

}
